// Informações de contato centralizadas
export const CONTACT_INFO = {
  email: 'suporte@heartapp.com.br',
  phone: {
    display: '(11) 98899-0011',
    link: 'tel:+5511988990011',
    raw: '5511988990011',
  },
  whatsapp: {
    number: '5511988990011',
    defaultMessage: 'Olá! Gostaria de conhecer o Heart.',
    supportMessage: 'Olá! Preciso de ajuda com a plataforma Heart.',
  },
} as const;

export function getWhatsAppUrl(message?: string): string {
  const msg = message ?? CONTACT_INFO.whatsapp.defaultMessage;
  return `https://wa.me/${CONTACT_INFO.whatsapp.number}?text=${encodeURIComponent(msg)}`;
}

export function getMailtoUrl(subject?: string): string {
  if (subject) {
    return `mailto:${CONTACT_INFO.email}?subject=${encodeURIComponent(subject)}`;
  }
  return `mailto:${CONTACT_INFO.email}`;
}

